<template>
  <FormsAndChecklists v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import { Filter } from "@/components/DatatableV3.vue";
import FormsAndChecklists from "@/Reports/FormsAndChecklists.vue";

const initialData = ref<{
  source: string;
  filters: Filter[];
} | null>(null);

onMounted(async () => {
  // Load initial page data and send to component as props
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });

  // The endpoint 404s when custom_forms_ff_enabled is off, and the Vue router
  // still resolves this page. Parsing that response would reject unhandled and
  // leave a blank page with only a console error to explain it.
  if (!res.ok) return;

  initialData.value = await res.json();
});
</script>

<style scoped></style>
